import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { GithubOutlined } from '@ant-design/icons';

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

const Footer = () => {
  return (
    <AntFooter className="blog-footer" style={{ textAlign: 'center', marginTop: 'auto' }}>
      <Space direction="vertical" size="small">
        <Text type="secondary">© 2025 Qmau的博客. 由 React 和 Ant Design 驱动</Text>
        <Space size="large">
          <Link href="/my">我的</Link>
          <Link href="#">GitHub <GithubOutlined /></Link>
        </Space>
      </Space>
    </AntFooter>
  );
};

export default Footer;